export const MESSAGE_FETCH_SUCCESS = "MESSAGE_FETCH_SUCCESS";
export const MESSAGE_FETCH_FAILED = "MESSAGE_FETCH_FAILED";

export const MESSAGE_UPDATE_SUCCESS = "MESSAGE_UPDATE_SUCCESS";
export const MESSAGE_UPDATE_FAILED = "MESSAGE_UPDATE_FAILED";

export const SHOW_PAGINATION_PROGRESS = "SHOW_PAGINATION_PROGRESS";
